__turbopack_context__.v({
  "section": "filter-faq-module-scss-module__OJWIyG__section",
  "title": "filter-faq-module-scss-module__OJWIyG__title",
});
